import { ScreenerSuggestion } from '@/types/common';
import { CheckRun, EffectiveDecision } from '@/types/crm-screener';

export type CheckName = 'analyzer' | 'geo';

export class CheckRunModel implements CheckRun {
  check: CheckName;
  outcome: ScreenerSuggestion;
  code: string;
  detail?: { [key: string]: any };
  ran_at: Date;

  constructor(payload: CheckRun) {
    this.check = payload.check as CheckName;
    this.outcome = payload.outcome as ScreenerSuggestion;
    this.code = payload.code;
    this.detail = payload.detail;
    this.ran_at = payload.ran_at;
  }
}

export class EffectiveDecisionModel implements EffectiveDecision {
  decision: ScreenerSuggestion;
  checks: CheckRunModel[];

  constructor(payload: EffectiveDecision) {
    this.decision = payload.decision as ScreenerSuggestion;
    this.checks = (payload.checks ?? []).map((c) => new CheckRunModel(c));
  }

  getCheck(name: CheckName): CheckRunModel | undefined {
    return this.checks.find((c) => c.check === name);
  }
}
